import React, { useState, useEffect, Component } from 'react'
import PropTypes from 'prop-types'
import NewsItem from './NewsItem'
import Spineer from './Spineer';
import InfiniteScroll from "react-infinite-scroll-component";

const News = (props) => {




  const fetchMoreData = async () => {
    const url = `https://newsapi.org/v2/top-headlines?country=${props.country}&category=${props.category}&apiKey=${props.apiKey}&page=${page+1}&pageSize=${props.pageSize}`;
    setPage(page+1)
    let data = await fetch(url);
    let parsedData = await data.json()
    setArticles(articles.concat(parsedData.articles))
    setTotalResults(parsedData.totalResults)
  };

  const capitalizeFirstletter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
    // return string.charAt(0).toUppercase()+string.slice(1);
  }

  const [articles, setArticles] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [totalResults, setTotalResults] = useState(0)
  


  const updateNews = async () => {
    props.setProgress(10);
    let url = `https://newsapi.org/v2/top-headlines?country=${props.country}&category=${props.category}&apiKey=${props.apiKey}&page=${page}&pageSize=${props.pageSize}`;
    setLoading(true)
    let data = await fetch(url);
    props.setProgress(35);
    let parsedData = await data.json();
    props.setProgress(70);
    //console.log(parsedData);
    setArticles(parsedData.articles)
    setTotalResults(parsedData.totalResults)
    setLoading(false)
    props.setProgress(100);
  }

  useEffect(() => {
    document.title = `${capitalizeFirstletter(props.category)}- NewsMonkey`
    updateNews();
  }, [])
  


  const handlePrevClick = async () => {
    setPage(page-1)
    updateNews();
  }

  const handleNextClick = async () => {
    setPage(page+1)
    updateNews();
  }



  return (
    <>

      <h3 className="text-center" style={{margin:'30px 0px',marginTop:'70px',marginBottom:'5px' }}>NewsMoney -Top {capitalizeFirstletter(props.category)} Headlines</h3>
      {loading && <Spineer />}

      <InfiniteScroll
        dataLength={articles.length} //This is important field to render the next data
        next={fetchMoreData}
        hasMore={articles.length != totalResults}

        loader={<Spineer />}
      >

        <div className="container">
          <div className="row">
            {articles.map((element) => {
              return <div className="col-md-4" key={element.url}>
                <NewsItem title={element.title ? element.title : ""}
                  // .slice(0, 50) 
                  description={element.description ? element.description : ""}
                  imgurl={element.urlToImage}
                  newsurl={element.url} author={element.author} date={element.publishedAt} source={element.source.name} />
              </div>
            })}
          </div>
        </div>

        {/* <div className="d-flex justify-content-between">
              <button type="button" disabled={page <= 1} onClick={handlePrevClick} className="btn btn-sm btn-dark">&larr; Previous</button>
               <button type="button" disabled={page + 1 > Math.ceil(totalResults /props.pageSize)} onClick={handleNextClick} className="btn btn-sm btn-dark">Next &rarr;</button>
                 </div> */}

      </InfiniteScroll>

    </>





  )

}

News.defaultProps = {
  country: 'in',
  pageSize: 8,
  category: 'general',
}
News.propTypes = {
  country: PropTypes.string,
  pageSize: PropTypes.number,
  category: PropTypes.string,
}

export default News
